(function () {
  const SCROLL_THRESHOLD = 8;

  function initTransparentHeader() {
    if (!document.documentElement.classList.contains('transparent-header-active')) return;

    const header = document.querySelector('.section-header');
    const wrapper = document.querySelector('.header-wrapper--transparent');
    const announcement = document.querySelector('.announcement-bar-section');
    if (!header || !wrapper) return;

    let spacer = document.querySelector('.section-header-spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'section-header-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      header.insertAdjacentElement('afterend', spacer);
    }

    function getAnnouncementHeight() {
      return announcement ? announcement.offsetHeight : 0;
    }

    function setHeaderHeight() {
      const height = header.offsetHeight;
      const announcementHeight = getAnnouncementHeight();
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
      spacer.style.display = 'block';
      spacer.style.height = `${height}px`;
    }

    function updateHeaderState() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      const announcementHeight = getAnnouncementHeight();
      setHeaderHeight();

      const pinned = scrollTop > SCROLL_THRESHOLD;
      header.classList.toggle('section-header--is-fixed', true);
      wrapper.classList.toggle('header-wrapper--solid', pinned);

      if (pinned || scrollTop >= announcementHeight) {
        header.style.top = '0px';
      } else {
        header.style.top = `${Math.max(0, announcementHeight - scrollTop)}px`;
      }
    }

    window.addEventListener('scroll', updateHeaderState, { passive: true });
    window.addEventListener('resize', updateHeaderState, { passive: true });
    updateHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransparentHeader);
  } else {
    initTransparentHeader();
  }
})();
